import { ApolloError } from '@apollo/client'
import {
  GetTaskDetailsDocument,
  GetTaskDetailsQueryVariables,
  TaskDetailFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { TaskAssignee } from 'modules/tasks/components/TasksList/types'

export interface TaskDetail extends TaskDetailFragment {
  assignees: TaskAssignee[]
  assigneesCount: number
}

interface UseTaskDetails {
  task?: TaskDetail
  loading: boolean
  error: ApolloError | undefined
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  canEmployeeManageAnyEmployeeFolder: boolean
}

export const useTaskDetails = (variables: GetTaskDetailsQueryVariables): UseTaskDetails => {
  const { data, loading, error } = useQuery(GetTaskDetailsDocument, { variables })

  const task = data?.tasks.tasks[0]

  if (!task)
    return {
      task: undefined,
      loading: loading,
      error: error,
      canSeePersonalInfo: false,
      canEditPersonalInfo: false,
      canEmployeeManageAnyEmployeeFolder: false,
    }

  const assignees = task?.assigneesConnection.nodes || []
  const assigneesCount = task?.assigneesConnection.totalCount || 0

  const canSeePersonalInfo =
    task?.affecteesConnection.edges[0]?.node.employee?._policies?.readPersonalInfo.can || false
  const canEditPersonalInfo =
    task?.affecteesConnection.edges[0]?.node.employee?.access.personalInfo?._policies?.edit.can ||
    false
  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can || false

  return {
    task: { ...task, assignees, assigneesCount },
    loading: loading,
    error: error,
    canSeePersonalInfo,
    canEditPersonalInfo,
    canEmployeeManageAnyEmployeeFolder,
  }
}
